<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="连接条件">
        <el-radio-group  v-model="formData.text" @change="selectYN">

          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
          <el-radio label=''>无</el-radio>
        </el-radio-group>
      </el-form-item>

    </el-form>


  </div>
</template>
<script>
  import { Sketch } from 'vue-color'
  import { shortStyles, borderStyles, fontFamilies } from '../constant'

  export default {
  name: '',
    components: {
      SketchPicker: Sketch
    },
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    const { properties } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }

  },
  data() {
    return {
      shortStyles,
      borderStyles,

      formData: {
        text:'是',
        exp:true,
        style: {
          backgroundColor: '', // 填充色
          gradientColor: '', // 渐变色
          borderType: 0, // 线条类型
          borderColor: 'rgb(16,119,80)', // 填充颜色
          borderWidth: 1, // 线条宽度
          borderStyle: '', // 线条类型
          fontSize: 12, // 文本大小
          fontColor: '', // 文本颜色
          fontWeight: '', // 文本加粗
          fontFamily: '', // 文本样式
          lineHeight: '', // 行高
          textAlign: '' // 对齐
        }
      }
    }
  },
  methods: {
    setStyle (item) {
      this.$emit('setStyle', item)
    },
    selectYN (val) {

      //console.log(val);
      this.$nextTick(()=> {

        const borderCY = 'rgb(16,119,80)';
        const borderCN = 'rgb(173,99,14)';
        if (val=="是") this.formData.exp=true;
        if (val=="否") this.formData.exp =false;
        if (val=="") this.formData.exp =true;
        this.formData.style['borderColor'] = (val=="否") ? borderCN : borderCY;
        this.$emit('setStyle', {
          ['borderColor']: (val=="否") ? borderCM : borderCY,
        })
      })

    },




  }
}
</script>
<style scoped>
  .diagram-panel {
    padding: 20px;
  }
  .short-styles {
    width: 240px;
  }
  .short-styles > div {
    width: 20px;
    height: 20px;
    margin: 0 10px 5px 0;
    box-sizing: border-box;
    float: left;
    border: 1px solid #fff;
    cursor: pointer;
  }
  .border-style {
    width: 150px;
    height: 0px;
    margin-top: 18px;
    border-bottom-width: 1px;
    border-bottom-color: black;
  }
  .setting-block {
    overflow: hidden;
  }
  .setting-item {
    line-height: 12px;
    font-size: 12px;
    display: flex;
    vertical-align: middle;
    align-items: center;
    margin-top: 10px;
  }
  .setting-item > span {
    width: 50px;
    margin-right: 10px;
    text-align: right;
    flex-shrink: 0;
    flex-grow: 0;
  }
  .border-color {
    width: 40px;
    height: 30px;
    display: inline-block;
    border: 1px solid #eaeaeb;
  }
</style>
